<template>
    <form v-if="loading === false">
        <h4>Informations</h4>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label" for="label">Nom*</label>
            <div class="col-sm-5">
                <input class="form-control"
                       id="label"
                       name="label"
                       placeholder="Joyeuses Pâques"
                       type="text" v-model="model.label">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label"
                   for="name">Identifiant*</label>
            <div class="col-sm-5 text-center">
                <input class="form-control"
                       id="name"
                       name="name" type="text"
                       v-model="model.name">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label"
                   for="need_internet">Requiert Internet</label>
            <div class="col-sm-2 text-center">
                <input class="form-check-input"
                       id="need_internet"
                       name="need_internet" type="checkbox"
                       v-model="model.need_internet">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label"
                   for="restricted">Restreint à un client</label>
            <div class="col-sm-2 text-center">
                <input class="form-check-input"
                       id="restricted"
                       name="restricted" type="checkbox"
                       v-model="model.restricted">
            </div>
        </div>
        <div class="form-group row" v-if="model.restricted == true">
            <label class="col-sm-4 col-form-label"
                   for="companies">Clients</label>
            <div class="col-sm-5 text-center">
                <tags-input :existing-tags="companies"
                            :only-existing-tags="true"
                            :typeahead="true"
                            :typeahead-hide-discard="true"
                            :typeahead-max-results="5"
                            :typeahead-style="'dropdown'"
                            element-id="tags"
                            placeholder="Entrez un client"
                            v-model="model.companies"></tags-input>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label"
                   for="code">Code source</label>
            <textarea class="form-control" id="code" rows="6" v-model="model.code"></textarea>
        </div>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label"
                   for="image">Image d'illustration</label>
            <div class="custom-file">
                <input @change="handleFileUpload" class="custom-file-input" id="image" type="file">
                <label class="custom-file-label" for="customFile" v-text="filename"></label>
            </div>
        </div>

        <hr>
        <h4>Champs associés au modèle <span class="btn btn-primary" v-on:click="addField()">Ajouter un champ</span>
            <span class="btn btn-primary" v-on:click="addArrayField()">Ajouter un tableau de champs</span></h4>
        <hr>
        <div v-for="(field, index) in model.fields" v-if="model != null && field.parent_id == null">
            <h6>Champ {{ field.label }} (<span class="btn-link" v-on:click="deleteField(field, index)">Supprimer</span>)
            </h6>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label" for="label[]">Nom</label>
                <div class="col-sm-4">
                    <input class="form-control "
                           id="label[]"
                           name="label[]"
                           type="text"
                           v-model="field.label">
                </div>
                <label class="col-sm-2 col-form-label"
                       for="name[]">Identifiant</label>
                <div class="col-sm-4 text-center">
                    <input class="form-control"
                           id="name[]"
                           name="name[]" type="text"
                           v-model="field.name">
                </div>
            </div>
            <div class="row" v-if="field.type === 'array'">
                <p v-if="field.id == null">Veuillez au préalable enegistrer.</p>
                <div class="col-10 offset-2" v-if="field.id != null">
                    <h5>Champ associé au tableau {{ field.label }} <span class="btn btn-primary btn-sm"
                                                                         v-on:click="addField(field.id)">Ajouter un champ</span>
                    </h5>
                    <div v-for="(subfield, subindex) in model.fields"
                         v-if="model != null && subfield.parent_id == field.id">
                        <h6>Champ {{ subfield.label }} (<span class="btn-link"
                                                              v-on:click="deleteField(field, subindex)">Supprimer</span>)
                        </h6>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label" for="label[]">Nom</label>
                            <div class="col-sm-4">
                                <input class="form-control "
                                       id="label[]"
                                       name="label[]"
                                       type="text"
                                       v-model="subfield.label">
                            </div>
                            <label class="col-sm-2 col-form-label"
                                   for="name[]">Identifiant</label>
                            <div class="col-sm-4 text-center">
                                <input class="form-control"
                                       id="name[]"
                                       name="name[]" type="text"
                                       v-model="subfield.name">
                            </div>
                        </div>
                        <div class="form-group row" v-if="subfield.type !== 'array'">
                            <label class="col-sm-2 col-form-label"
                                   for="type[]">Type</label>
                            <div class="col-sm-4 text-center">
                                <select class="form-control" id="type[]"
                                        name="type[]" v-model="subfield.type">
                                    <option value="">Veuillez séléctionner...</option>
                                    <option value="text">Texte</option>
                                    <option value="color">Couleur</option>
                                    <option value="date">Date</option>
                                    <option value="image">Image</option>
                                    <option value="select">Liste déroulante</option>
                                </select>
                            </div>
                            <label class="col-sm-2 col-form-label"
                                   for="default[]">Valeur par défaut</label>
                            <div class="col-sm-4 text-center">
                                <input class="form-control"
                                       id="default[]"
                                       name="default[]"
                                       type="text" v-if="'text' === subfield.type"
                                       v-model="subfield.default">
                                <chrome-picker :value="subfield.default"
                                               @input="e => subfield.default = e.hex.substr(1)"
                                               v-if="subfield.type === 'color'"></chrome-picker>
                                <select class="form-control" id="default[]"
                                        name="default[]" v-if="subfield.type === 'select'" v-model="subfield.default">
                                    <option value="">Veuillez séléctionner...</option>
                                    <option :value="value.value" v-for="(value, index) in subfield.available_values">
                                        {{ value.label}}
                                    </option>
                                </select>
                                <VueCtkDateTimePicker :format="'YYYY-MM-DD hh:mm:ss'" :label="'Date'"
                                                      :output-format="'YYYY-MM-DD hh:mm:ss'"
                                                      v-if="'date' === subfield.type"
                                                      v-model="subfield.default"/>
                                <div class="custom-file" v-if="subfield.type === 'image'">
                                    <input @change="processFile($event, subfield)" class="custom-file-input"
                                           id="customFile"
                                           type="file">
                                    <label class="custom-file-label" for="customFile">Choisissez un fichier...</label>
                                </div>
                            </div>
                            <div class="col-12" v-if="subfield.type === 'image' && subfield.default != null">
                                <p>Image actuelle: </p>
                                <img alt="" height="300" v-bind:src="subfield.image"
                                     v-if="subfield.image !== undefined"/>
                                <img alt="" height="300" v-bind:src="subfield.default"
                                     v-if="subfield.image === undefined"/>
                            </div>
                        </div>
                        <div v-if="subfield.type === 'select'">
                            <div class="form-group row">
                                <label
                                        class="col-sm-2 col-form-label">Valeurs possible</label>
                            </div>
                            <div class="form-group row" v-for="(value, index) in subfield.available_values">
                    <span class="col-sm-2 btn btn-danger" href="#"
                          v-on:click="deleteOption(index, subfield)">Supprimer</span>
                                <label class="col-sm-2 col-form-label"
                                       for="available[][]">Texte</label>
                                <div class="col-sm-3 text-center">
                                    <input class="form-control"
                                           id="available[][]"
                                           name="available[][]" type="text"
                                           v-model="value.label" v-on:change="update">
                                </div>
                                <label class="col-sm-2 col-form-label"
                                       for="available_v[][]">Valeur</label>
                                <div class="col-sm-3 text-center">
                                    <input class="form-control"
                                           id="available_v[][]"
                                           name="available_v[][]" type="text"
                                           v-model="value.value" v-on:change="update">
                                </div>
                            </div>
                            <div class="row">
                                <span class="btn btn-success col-sm-2" v-on:click="addOption(subfield)">Ajouter</span>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
            <div class="form-group row" v-if="field.type !== 'array'">
                <label class="col-sm-2 col-form-label"
                       for="type[]">Type</label>
                <div class="col-sm-4 text-center">
                    <select class="form-control" id="type[]"
                            name="type[]" v-model="field.type">
                        <option value="">Veuillez séléctionner...</option>
                        <option value="text">Texte</option>
                        <option value="color">Couleur</option>
                        <option value="date">Date</option>
                        <option value="image">Image</option>
                        <option value="select">Liste déroulante</option>
                    </select>
                </div>
                <label class="col-sm-2 col-form-label"
                       for="default[]">Valeur par défaut</label>
                <div class="col-sm-4 text-center">
                    <input class="form-control"
                           id="default[]"
                           name="default[]"
                           type="text" v-if="'text' === field.type"
                           v-model="field.default">
                    <chrome-picker :value="field.default" @input="e => field.default = e.hex.substr(1)"
                                   v-if="field.type === 'color'"></chrome-picker>
                    <select class="form-control" id="default[]"
                            name="default[]" v-if="field.type === 'select'" v-model="field.default">
                        <option value="">Veuillez séléctionner...</option>
                        <option :value="value.value" v-for="(value, index) in field.available_values">
                            {{ value.label}}
                        </option>
                    </select>
                    <VueCtkDateTimePicker :format="'YYYY-MM-DD hh:mm:ss'" :label="'Date'"
                                          :output-format="'YYYY-MM-DD hh:mm:ss'" v-if="'date' === field.type"
                                          v-model="field.default"/>
                    <div class="custom-file" v-if="field.type === 'image'">
                        <input @change="processFile($event, field)" class="custom-file-input" id="customFile"
                               type="file">
                        <label class="custom-file-label" for="customFile">Choisissez un fichier...</label>
                    </div>
                </div>
                <div class="col-12" v-if="field.type === 'image' && field.default != null">
                    <p>Image actuelle: </p>
                    <img alt="" height="300" v-bind:src="field.image" v-if="field.image !== undefined"/>
                    <img alt="" height="300" v-bind:src="field.default" v-if="field.image === undefined"/>
                </div>
            </div>
            <div v-if="field.type === 'select'">
                <div class="form-group row">
                    <label
                            class="col-sm-2 col-form-label">Valeurs possible</label>
                </div>
                <div class="form-group row" v-for="(value, index) in field.available_values">
                    <span class="col-sm-2 btn btn-danger" href="#"
                          v-on:click="deleteOption(index, field)">Supprimer</span>
                    <label class="col-sm-2 col-form-label"
                           for="available[][]">Texte</label>
                    <div class="col-sm-3 text-center">
                        <input class="form-control"
                               id="available[][]"
                               name="available[][]" type="text"
                               v-model="value.label" v-on:change="update">
                    </div>
                    <label class="col-sm-2 col-form-label"
                           for="available_v[][]">Valeur</label>
                    <div class="col-sm-3 text-center">
                        <input class="form-control"
                               id="available_v[][]"
                               name="available_v[][]" type="text"
                               v-model="value.value" v-on:change="update">
                    </div>
                </div>
                <div class="row">
                    <span class="btn btn-success col-sm-2" v-on:click="addOption(field)">Ajouter</span>
                </div>
            </div>
            <hr>
        </div>
        <div class="row">
            <div class="col-12 col-md-4 offset-md-4">
                <span v-bind:class="{'btn btn-primary btn-block': status === 'Enregistrer', 'btn btn-success btn-block': status === 'Succès !', 'btn btn-danger btn-block': status === 'Erreur'}"
                      v-on:click="submit()"><i
                        v-bind:class="{'fas fa-chess-board fa-lg' : status === 'Enregistrer', 'fas fa-check fa-lg': status === 'Succès !', 'fas fa-times fa-lg': status === 'Erreur'}"></i>&nbsp; {{ status }}
                </span>
            </div>
        </div>

    </form>
</template>

<script>
    export default {
        props: ['model_id'],
        data: function () {
            return {
                companies: [],
                tag: '',
                tags: [],
                loading: true,
                model: [],
                status: 'Enregistrer',
                filename: 'Choisir un fichier',
            }
        },
        computed: {},
        mounted: function () {
            axios.post('/admin/companies/list?smartcity', {})
                .then(response => {
                    response.data.forEach((company) => {
                        this.companies.push({value: company.name, key: company.id})
                    });
                    if (this.model_id !== 0) {
                        axios.post('/smartcity/admin/models/' + this.model_id + '/json', {})
                            .then(response => {
                                this.model = response.data;
                                this.model.fields.forEach((field) => {
                                    if (field.available_values != null) {
                                        field.available_values = JSON.parse(field.available_values);
                                    }
                                });
                                var companies = [];
                                this.model.companies.forEach((company_relation) => {
                                    companies.push(this.companies[this.companies.map(function (e) {
                                        return e.key;
                                    }).indexOf(company_relation.id)]);
                                });
                                this.model.companies = companies;
                                this.loading = false;
                            });
                    } else {
                        this.model = {
                            name: '',
                            id: null,
                            image_path: '',
                            label: '',
                            need_internet: 0,
                            restricted: 0,
                            description: '',
                            fields: [],
                            companies: [],
                            parent_id: null
                        };
                        this.loading = false;
                    }
                });

        },
        methods: {
            deleteOption: function (index, field) {
                field.available_values.splice(index, 1);
                this.$forceUpdate();
            },
            addOption: function (field) {
                field.available_values[field.available_values.length] = {"label": "", "value": ""};
                this.$forceUpdate();
            },
            addField: function (field_id = null) {
                this.model.fields.push({
                    available_values: [],
                    default: '',
                    id: null,
                    label: '',
                    model_id: this.model_id,
                    name: '',
                    parent_id: field_id,
                    placeholder: '',
                    type: ''
                });
            },
            addArrayField: function () {
                this.model.fields.push({
                    available_values: [],
                    default: '',
                    id: null,
                    label: '',
                    model_id: this.model_id,
                    name: '',
                    parent_id: null,
                    placeholder: '',
                    type: 'array'
                });
            },
            deleteField: function (field, index) {
                if (field.type === 'array') {
                    this.model.fields.forEach((f, i) => {
                        if (f.parent_id === field.id) {
                            this.model.fields.splice(i, 1);
                        }
                    });
                }
                this.model.fields.splice(index, 1);
            },
            update: function () {
                this.$forceUpdate();
            },
            processFile: function (event, field) {
                field.default = event.target.files[0];
                field.image = null;
                var reader = new FileReader();
                reader.onload = function () {
                    field.image = reader.result;
                    this.$forceUpdate();
                }.bind(this);
                reader.readAsDataURL(field.default);
                this.$forceUpdate();
            },
            submit: function () {
                let formData = new FormData();
                formData.append('model', JSON.stringify(this.model));
                formData.append('image', this.model.image);
                axios
                    .post('/smartcity/admin/models/' + ((this.model_id === 0) ? 'create' : this.model_id + '/edit'),
                        formData,
                        {
                            headers: {'Content-Type': 'multipart/form-data'}
                        }).then(response => {
                    if (response.status === 200) {
                        this.status = 'Succès !';
                        this.model = response.data;
                        this.model.fields.forEach((field) => {
                            if (field.available_values != null) {
                                field.available_values = JSON.parse(field.available_values);
                            }
                        });
                        var companies = [];
                        this.model.companies.forEach((company_relation) => {
                            companies.push(this.companies[this.companies.map(function (e) {
                                return e.key;
                            }).indexOf(company_relation.id)]);
                        });
                        this.model.companies = companies;
                        setTimeout(() => {
                            this.status = 'Enregistrer';
                        }, 5000);
                    } else {
                        this.status = 'Erreur';
                        setTimeout(() => {
                            this.status = 'Enregistrer';
                        }, 5000);
                    }
                    this.model_id = response.data.id;
                });
            },
            handleFileUpload: function (e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.model.image = files[0];
                this.filename = files[0].name;
            }
        }
    }
</script>
